module.exports = __webpack_public_path__ + "img/8.0fc8c139.jpg";